import React from 'react';
import { Link } from 'react-router-dom';
import Tooltip from '../../Tooltip/Tooltip';
import MapTooltip from '../../Map/MapTooltip';
import AddressTooltip from '../../Address/AddressTooltip';

export default function PropertyWidget(props) {
	// console.log('PropertyWidget', props);
	return (
		<div>
			<div>
				<Link to={`/properties/${props.id}`} onClick={props.onClick}>
					<span className="text-tt-blue-900 my-1 hover:underline">
						{props.name}
					</span>
				</Link>
			</div>
			<div>
				<span className="ml-0.5">
					<Tooltip text={<MapTooltip />} placement="right">
						<i className="fa fa-map-marker text-gray-700" aria-hidden="true" />
					</Tooltip>{' '}
					{props.city}, {props.state}
				</span>
			</div>
		</div>
	);
}
